import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import WhatIfDocumentTableDto from '../dto/WhatIfDocumentTableDto';

class WhatIfDocumentTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'whatIfDocumentTableControl';
	}

	/**
	 * Backward compatible getList:
	 * - new style: getList(session, firstResult, maxResults, whatIf?, documentItemId?)
	 * - old style: getList(whatIf, session, firstResult, maxResults)
	 *
	 * @return {Promise<GenericTableDto<WhatIfDocumentTableDto>>}
	 */
	getList(a, b, c, d, e) {
		let session;
		let firstResult;
		let maxResults;
		let whatIf;
		let documentItemId;

		if (typeof a === 'string' || a === null || typeof a === 'undefined') {
			// new style: (session, firstResult, maxResults, whatIf, documentItemId)
			session = a;
			firstResult = b;
			maxResults = c;
			whatIf = d;
			documentItemId = e;
		} else {
			// old style: (whatIf, session, firstResult, maxResults)
			whatIf = a;
			session = b;
			firstResult = c;
			maxResults = d;
		}

		const payload = {
			session,
			firstResult,
			maxResults
		};

		if (typeof whatIf !== 'undefined' && whatIf !== null) {
			payload.whatIf = whatIf;
		}

		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, payload)
				.then(response => {
					// response.data: { data: [], metadata: {}, selected: [] }
					const src = response.data || {};
					const list = Array.isArray(src.data) ? src.data : [];
					const meta = src.metadata || {};
					const selected = Array.isArray(src.selected) ? src.selected : [];

					const hasDocFilter =
						typeof documentItemId !== 'undefined' &&
						documentItemId !== null &&
						String(documentItemId).trim() !== '';

					if (!hasDocFilter) {
						resolve(new GenericTableDto().setup(src, WhatIfDocumentTableDto));
						return;
					}

					const docKey = String(documentItemId);

					// Szűrés: tipikusan documentItemKey alapján, de ha mégis id-t adsz át, azt is elfogadjuk.
					const filteredList = list.filter(row => {
						if (!row) return false;
						return (
							String(row.documentItemKey) === docKey ||
							String(row.id) === docKey ||
							String(row.key) === docKey
						);
					});

					const filteredSelected = selected.filter(row => {
						if (!row) return false;
						return (
							String(row.documentItemKey) === docKey ||
							String(row.id) === docKey ||
							String(row.key) === docKey
						);
					});

					const next = {
						...src,
						data: filteredList,
						selected: filteredSelected,
						metadata: {
							...meta,
							first: 0,
							currentCount: filteredList.length,
							totalCount: filteredList.length,
							selectedCount: filteredSelected.length
						}
					};

					resolve(new GenericTableDto().setup(next, WhatIfDocumentTableDto));
				})
				.catch(reject);
		});
	}
}

export default new WhatIfDocumentTableService();
